import React from 'react';
import PageHero from '../components/layout/PageHero';
import RegenBrakingSimulator from '../components/tools/RegenBrakingSimulator';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import { Alert, AlertTitle, AlertDescription } from '../components/ui/alert';
import { Info } from 'lucide-react';

const RegenBrakingSimulatorPage = () => (
  <div className="min-h-screen" data-testid="regen-braking-simulator-page">
    <PageHero
      eyebrow="Engineering Utilities"
      title="Regenerative Braking Blending Simulator"
      description="Split every braking step of a drive cycle between regen and friction brakes, limited by battery SoC and temperature, motor torque and axle stability, and see the range regen buys you."
      testId="regen-braking-simulator-hero"
    />
    <section className="py-12 md:py-16">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-8 space-y-6">
        <Alert data-testid="regen-assumptions-note">
          <Info className="h-4 w-4" />
          <AlertTitle className="font-chivo uppercase tracking-tight text-sm">Assumptions</AlertTitle>
          <AlertDescription>
            Uses the EV Powertrain Simulator's quasi-static drive-cycle engine (flat road, the
            cycle's speed trace followed exactly) with a regen blending policy on top. Battery
            charge limits come from the Charging Simulator's chemistry-typical BMS tables, which
            are continuous charge limits — real packs accept somewhat more for a few-second regen
            pulse. It is an <strong>engineering approximation</strong> of a brake-by-wire blending
            controller, not any manufacturer's calibration. See the User Guide's Assumptions
            &amp; Limitations section.
          </AlertDescription>
        </Alert>
        <RegenBrakingSimulator />
        <ToolGuideCta guidePath="/simulation/regen-braking/guide" toolName="Regenerative Braking Blending Simulator" />
      </div>
    </section>
  </div>
);

export default RegenBrakingSimulatorPage;
